import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import UsedCarsWelcome from 'components/UsedCarsWelcome';
import Layout from 'components/Layout';
import LeaderboardAds from 'components/Ad/LeaderboardAds';

export default function UsedCarsWelcomePage(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <Layout
        showHeader={false}
        footer={<div />}
        title={t(`main.meta.pageTitle`)}
        description={t(`main.meta.metaDescription`)}
        indexed={false}
      >
        <LeaderboardAds />
        <UsedCarsWelcome />
      </Layout>
    </>
  );
}
